import { frontendURL } from '../../../../helper/URLHelper';
import store from 'dashboard/store';

import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';

// ACESSO-01 (L9a): com a chave ACESSO_GRANULAR ligada, os papéis se montam na tela nova (`papeis.routes.js`), e a de
// hoje leva para lá. O `custom_roles_wrapper` redireciona para a lista, e é nela que se confere a chave: o
// redirecionamento roda antes do `setUser` na primeira carga, e o `beforeEnter`, depois.
const naTelaNovaComAChave = to =>
  store.getters['acesso/ligado'] === true
    ? { name: 'papeis_lista', params: { accountId: to.params.accountId } }
    : true;

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/custom-roles'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'custom_roles_wrapper',
          // Montar papel é entregar permissão, então quem monta pode se promover: só
          // `administrator`, sem permissão nomeada que delegue isto. Mesmo corte do
          // `CustomRolePolicy` no backend.
          meta: {
            permissions: ['administrator'],
            // ACESSO-01 (L8b): montar papel (`custom_roles#*`), que não se concede: o modelo Administrador.
            escopos: ['roles:manage'],
          },
          redirect: to => {
            return { name: 'custom_roles_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'custom_roles_list',
          meta: {
            permissions: ['administrator'],
            // ACESSO-01 (L8b): montar papel (`custom_roles#*`), que não se concede: o modelo Administrador.
            escopos: ['roles:manage'],
          },
          beforeEnter: naTelaNovaComAChave,
          component: Index,
        },
      ],
    },
  ],
};
